export enum GlsOrderStatus {
    SHIPMENT_AWAITING = 'SHIPMENT_AWAITING',
    PARCEL_CREATED = 'PARCEL_CREATED',
}
